import request from '@/utils/request'

// 保持可注入，便于核验 URL、query/body 与日结/充值分支，而不触发真实审核。
export function createTenantInvoiceApi (send) {
  const post = (path, params, data) => send({
    url: `/api/ebc-settle/${path}`,
    method: 'post',
    ...(params ? { params } : {}),
    ...(data ? { data } : {})
  })
  return {
    page: data => post('printInvoice/pageInvoiceManageRecord', null, data),
    pending: managerId => post('printInvoice/auditInvoiceManageSum', { managerId }),
    detail: invoiceManageId => post('printInvoice/getInvoiceDetails', { invoiceManageId }),
    bills: data => post('printInvoice/getInvoiceBillDetails', null, data),
    progress: eventId => post('pmgBar/pmgBarList', { eventId, pmgressbarType: 2 }),
    files: fpqqlsh => post('printInvoice/getPrintvoiceResult', { fpqqlsh }),
    quota: id => post('printInvoice/getManagerById', { id }),
    auditDaily: params => post('printInvoice/updateInvStatus', params),
    auditRecharge: params => post('printInvoice/updateRechangeInvoiceManage', params),
    redFlush: id => post('printInvoice/invoiceFastRedFlushed', { id }),
    completeManual: params => post('printInvoice/manualBill', params)
  }
}

export default createTenantInvoiceApi(request)
